import React, { useEffect, useState } from 'react';
import { Table, Tag, Button, Card, Space, Input, Row, Col, List } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getPromoCodes } from '../CreatePromoCodeAction';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';

const ListPromoCodes = ({ countries }) => {
  const dispatch = useDispatch();
  const promoCodes = useSelector(state => state.createPromoCode?.promoCodes || {});
  const promoCodesLoading = promoCodes.loading;
  const promoCodesList = promoCodes.data || [];
  const [searchText, setSearchText] = useState('');
  
  useEffect(() => {
    dispatch(getPromoCodes());
  }, [dispatch]);
  
  const getCountryName = (code) => {
    const country = countries.find(c => c.code === code);
    return country ? country.name : code;
  };
  
  const handleRefresh = () => {
    dispatch(getPromoCodes());
  };
  
  const filteredPromoCodesList = searchText
    ? promoCodesList.filter(
        promo => 
          promo.code?.toLowerCase().includes(searchText.toLowerCase()) ||
          promo.name?.toLowerCase().includes(searchText.toLowerCase())
      )
    : promoCodesList;
  
  // View promo code usage
//   const showPromoUsage = (code) => {
//     // Navigate to promo code usage page or show in modal
//     console.log(`View usage for: ${code}`);
//     // window.location.href = `/dashboard/promo-code-usage/${code}`;
//   };
  
  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      render: (text) => <strong>{text}</strong>,
      sorter: (a, b) => a.code?.localeCompare(b.code),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name?.localeCompare(b.name),
    },
    {
      title: 'Discount',
      key: 'discount',
      render: (_, record) => (
        <span>
          {record.discount?.amountType === 'PERCENTAGE' 
            ? `${record?.discount?.amount}%` 
            : `LKR ${record?.discount?.amount}`}
        </span>
      ),
      sorter: (a, b) => a.discount?.amount - b.discount?.amount,
    },
    {
      title: 'Country',
      key: 'country',
      render: (_, record) => (
        <Tag color="blue">
          {getCountryName(record.dependencyParam?.country)}
        </Tag>
      ),
      filters: countries.map(country => ({
        text: country.name,
        value: country.code,
      })),
      onFilter: (value, record) => record.dependencyParam?.country === value,
    },
    {
      title: 'Validity',
      key: 'validity',
      render: (_, record) => (
        <span>
          {moment(record.startDate).format('DD-MM-YYYY')} to {moment(record.endDate).format('DD-MM-YYYY')}
        </span>
      ),
      sorter: (a, b) => moment(a.startDate).unix() - moment(b.startDate).unix(),
    },
    {
      title: 'Usage Limit',
      dataIndex: 'usageLimit',
      key: 'usageLimit',
      sorter: (a, b) => a.usageLimit - b.usageLimit,
    },
    {
      title: 'Per User',
      dataIndex: 'individualUserUsageLimit',
      key: 'individualUserUsageLimit',
    },
    // {
    //   title: 'Actions',
    //   key: 'actions',
    //   render: (_, record) => (
    //     <Space>
    //       <Button size="small" type="primary" onClick={() => showPromoUsage(record.code)}>
    //         View Usage
    //       </Button>
    //     </Space>
    //   ),
    // },
  ];

  return (
    <Card 
      title="Promo Codes List" 
      bordered={false}
      extra={
        <Button 
          type="default" 
          icon={<ReloadOutlined />}
          onClick={handleRefresh}
        >
          Refresh
        </Button>
      }
    >
      <Row style={{ marginBottom: 16 }}>
        <Col>
          <Input
            placeholder="Search by name or code"
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            style={{ width: 250 }}
            allowClear
          />
        </Col>
      </Row>
      
      <Table 
        dataSource={filteredPromoCodesList} 
        columns={columns} 
        rowKey="code"
        loading={promoCodesLoading}
        pagination={{ 
          pageSize: 10,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
        }}
        size="middle"
        scroll={{ x: true }}
      />
    </Card>
  );
};

export default ListPromoCodes;